import { isBoolean } from 'lodash';
import React, { useEffect, useRef } from 'react';
import { getControlStyle } from '../helper';

export function TextArea(props) {
  const {
    placeHolder,
    rowIndex,
    colIndex,
    charCount,
    maxCount,
    onChange,
    CustomAddEditAccess,
    otherConfiguration,
    isProductArchived,
    fontSize,
    onHeightChange,
    fromLibrary,
  } = props;
  const styleInput = fontSize?.value ? { fontSize: `${fontSize?.value}px` } : { fontSize: '11px' };
  const combinedStyles = getControlStyle(otherConfiguration);
  let style = {};
  if (styleInput) {
    style = { ...combinedStyles, ...styleInput };
  }
  // Ref for the textarea
  const textareaRef = useRef(null);

  // Function to adjust textarea height
  const adjustTextareaHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = '20px'; // Reset height to auto
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set height based on scrollHeight
      // Trigger grid layout update

      if (textareaRef.current.scrollHeight > 0 && fromLibrary) {
        onHeightChange(textareaRef.current.scrollHeight);
      }
    }
  };

  // Trigger height adjustment on component mount and when value changes
  useEffect(() => {
    adjustTextareaHeight(); // Adjust height when the component mounts or the value changes
  }, [props?.value]);

  const handleTextareaKeyUp = (e) => {
    adjustTextareaHeight();
  };

  return (
    <div className="input-group input-floating-label fixed-label p-0 mb-0 remove-border-text-box">
      <label />
      <textarea
        ref={textareaRef}
        disabled={(isBoolean(CustomAddEditAccess) ? !CustomAddEditAccess : false) || isProductArchived}
        maxLength={maxCount}
        placeholder={placeHolder}
        onChange={(e) => onChange(e.target.value, rowIndex, colIndex)}
        onKeyUp={handleTextareaKeyUp}
        value={props?.value || ''}
        style={style}
        className="overflow-y-hidden"
      />

      {charCount && (
        <div className="text-count">
          {props?.value?.length || 0}/{maxCount}
        </div>
      )}
    </div>
  );
}

export default TextArea;
